import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import awardPrizeService from 'lib/services/awardPrizeService';
import { useAwardPrizeStore } from 'lib/store/awardPrize';
import { showModal } from 'lib/components/Modal';
import userOrderService from 'lib/services/userOrderService';
import { ORDER_STATE } from 'lib/constants/order';
import { fetchOrderPackage, fetchWUJIActivity } from 'lib/apis';
import { captchaModalInit } from 'lib/container/SMSCaptchaModal';
import { generatorOrderUrl, getGiftBtnType, getPackageName, getPureText } from 'lib/utils/util';
import channelService from 'lib/services/channelService';
import { showOrderMobileInput } from 'lib/components/MobileInput';
import { addReportPublicParams, report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { AWARD_TYPES } from 'lib/constants/award';
import { OPERATOR_TYPE } from 'lib/constants/operator';
import { currentUrlParams } from 'lib/utils/url';
import { useMobileStore } from 'lib/store/mobileStore';
import { useGlobalStore } from 'lib/store';
import './styles.scss';

export default function ReceiveButton({ data, commonStyle }) {
  const { activityId, receivedBtnImg, tobeReceiveBtnImg, btnType } = data;
  const receivedPrizeList = useAwardPrizeStore(state => state.receivedPrizeList);
  const isReceived = useMemo(() => receivedPrizeList.indexOf(+activityId) !== -1, [receivedPrizeList, activityId]);
  const mobileInput = useMobileStore(state => state.inputMobile);
  const globalStore = useGlobalStore(state => state);

  useEffect(() => {
    awardPrizeService.registerGiftData(+activityId, btnType);
  }, []);

  // 触发领奖
  const receiveGift = async () => {
    if (isReceived) {
      // 提示当前礼包已领取
      return;
    }
    addReportPublicParams({
      orderTriggerType: getGiftBtnType(btnType),
    });
    report(btnType === AWARD_TYPES.MUST ? ATTA_REPORT.RECEIVE_PRIZE.GIFT : ATTA_REPORT.RECEIVE_PRIZE.LOTTERY);
    const userOrderInfo = userOrderService.getUserOrderInfo();

    switch (userOrderInfo.orderState) {
      case ORDER_STATE.CANCELING:
      case ORDER_STATE.CANCEL_SUCCESS:
      case ORDER_STATE.ORDER_SUCCESS: {
        return awardPrizeService.receiveGift(+activityId);
      }

      case ORDER_STATE.PLACE_ORDER: {
        // 如果用户主动修改页面输入框上的手机号，则需要再次确认并走下单流程
        if (mobileInput !== userOrderInfo?.orderMobile) {
          showOrderMobileInput(btnType);
          return;
        }
        if (userOrderInfo?.operatorType === OPERATOR_TYPE.UNICOM) {
          const subStatTag = currentUrlParams.getCurrentParams('SubStatTag') || channelService.channelTag;
          const shareToken = currentUrlParams.getCurrentParams('shareToken');
          const redirectURL = generatorOrderUrl(userOrderInfo);
          const res = await fetchOrderPackage({
            packageId: userOrderInfo?.pId || '',
            channelCode: channelService.channelCode,
            mobile: userOrderInfo?.orderMobile || '',
            subStatTag,
            redirectURL,
            shareToken,
          });
          if (res?.code !== 0) return;
          const { url, orderMethod } = res?.data || {};

          if (url && orderMethod === 1) {
            window.location.href = url;
            return;
          }
          return;
        }
        const res = await fetchWUJIActivity();
        if (res?.code !== 0) return;
        const activityConfigList = res?.data || [];
        const {
          price_desc: packagePrice,
          package_name: packageName,
          is_promotional: isPromotional,
          subscribe_hint: orderTips,
        } = activityConfigList.find(c => c.p_id === userOrderInfo.pId) || {};
        const { smsModalTheme } = globalStore;
        showModal(
          captchaModalInit({
            channelCode: channelService.channelCode,
            mobile: userOrderInfo.orderMobile,
            operatorType: userOrderInfo.operatorType,
            packageId: userOrderInfo.pId,
            priceDesc: packagePrice,
            packageName: getPackageName(userOrderInfo.operatorType, isPromotional, packageName),
            orderTips: getPureText(orderTips),
            smsModalTheme,
            isPromotional,
          }),
          {
            onBottom: !!smsModalTheme,
          },
        );
        return;
      }

      default: {
        showOrderMobileInput(btnType);
        return;
      }
    }
  };

  return (
    <div
      className={classNames('receive-btn', {
        disabled: isReceived,
      })}
      id={`gift-${activityId}`}
      style={commonStyle}
      onClick={receiveGift}
      data-gift-btn-type={getGiftBtnType(btnType)}
      data-is-received={!!isReceived}
      data-test-id={`receive-${getGiftBtnType(btnType)}`}
    >
      <img className="btn-img" src={isReceived ? receivedBtnImg : tobeReceiveBtnImg} />
    </div>
  );
}
